interface IGetAllParentsIds<T> {
  data?: T[]
  keyFieldValue: string | number
  keyField: string
  hierarchyField: string
}

export const getAllParentsIds = <T>({
  data,
  hierarchyField,
  keyField,
  keyFieldValue,
}: IGetAllParentsIds<T>): (string | number)[] => {
  if (!data) {
    return []
  }
  const item = data.find((obj) => obj[keyField] === keyFieldValue)
  if (!item) {
    return []
  }

  const parentId = item[hierarchyField]

  const parentItem = data.find((obj) => obj[keyField] === parentId)

  if (!parentItem) {
    return []
  }
  return [
    parentId,
    ...getAllParentsIds({ data, keyFieldValue: parentId, keyField, hierarchyField }),
  ]
}
